export default {
  control: (provided, state) => {
    return {
      ...provided,
      "border-width": "2px",
      "border-style": "solid",
      "border-radius": "8px",
      "border-color": "#83DEFA !important",
      "cursor": "pointer",
      "background-color": "#2491DF",
    }
  },
  indicatorSeparator: (provided, state) => ({ ...provided, display: "none" }),
  singleValue: (provided, state) => {
    return {
      ...provided,
      "color": "white",
      "font-size": "15px"
    }
  },
  option: (provided, state) => {
    return {
      ...provided,
      "color": state.isFocused ? "white" : "black",
      "background-color": state.isFocused ? "#62C3E8" : "white"
    }
  },
  dropdownIndicator: (provided, state) => {
    return {
      ...provided,
      "color": "white"
    }
  },
  menu: (provided, state) => ({ ...provided, "overflow": "hidden", "z-index": "10" })
}
